import React, { useContext, useState } from 'react';
import { ActionModal } from '../../../../components/Modal';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { CompanyConnection } from '../../../../../types/companyConnection/companyConnection';
import { CompanyContext } from '../../../../../context/CompanyContext';
import useMutation from '../../../../../hooks/useMutation';
import {
  CompanyConnectionMutations,
  CreateCompanyAsPartnerResponse,
  CreateCompanyAsPartnerVariables,
} from '../../../../../graphql/companyConnection.graphql';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';
import { Button, ButtonVariant } from '../../../../components/Button';

import { TextInput } from '../../../../components/TextInput';

interface CreateCompanyAsPartnerModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function CreateCompanyAsPartnerModal({ open, setOpen }: CreateCompanyAsPartnerModalProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections, setCompanyConnections } = useContext(CompanyConnectionContext);

  const [name, setName] = useState<string>('');

  const [create, { loading }] = useMutation<CreateCompanyAsPartnerResponse, CreateCompanyAsPartnerVariables>(
    CompanyConnectionMutations.createAsPartner,
    {
      onCompleted: response => {
        const connection = response.createCompanyAsPartner;
        companyConnections.set(connection.id, new CompanyConnection(connection));
        setCompanyConnections(new Map(companyConnections));
        setOpen(false);
      },
    },
  );

  const valid = () => {
    return !!name;
  };

  const handleCreate = async () => {
    await create({ variables: { name: name } });
  };

  const footer = (
    <>
      <div className='grid grid-cols-2'>
        <div>
          <Button
            text={t(TranslationKey.cancel).singular.label}
            variant={ButtonVariant.secondary}
            onClick={() => setOpen(false)}
          />
        </div>
        <div className='flex justify-end'>
          <Button
            loading={loading}
            text={t(TranslationKey.create).singular.label}
            onClick={handleCreate}
            disabled={!valid()}
          />
        </div>
      </div>
    </>
  );

  return (
    <ActionModal open={open} setOpen={setOpen} title={t(TranslationKey.createCompany).plural.upper} footer={footer}>
      <div>
        <TextInput
          mandatory
          label={t(TranslationKey.companyName).singular.label}
          placeholder={t(TranslationKey.companyName).singular.label}
          value={name}
          onChange={v => setName(v)}
        />
      </div>
    </ActionModal>
  );
}
